
export const INITIAL_AUCTION_CATEGORIES = [
    {
      id: "electronics",
      name: "Electronics",
      arabicName: "الإلكترونيات",
      icon: "hardware-chip-outline",
      order: 1,
      active: true,
    },
    {
      id: "cars",
      name: "Cars",
      arabicName: "السيارات",
      icon: "car-sport-outline",
      order: 2,
      active: true,
    },
    {
      id: "motorcycles",
      name: "Motorcycles",
      arabicName: "الدراجات النارية",
      icon: "bicycle-outline",
      order: 3,
      active: true,
    },
    {
      id: "auto-parts",
      name: "Auto Parts",
      arabicName: "قطع غيار السيارات",
      icon: "construct-outline",
      order: 4,
      active: true,
    },
    {
      id: "boats",
      name: "Boats",
      arabicName: "القوارب",
      icon: "boat-outline",
      order: 5,
      active: true,
    },
    {
      id: "mobile-phones",
      name: "Mobile Phones",
      arabicName: "الهواتف المحمولة",
      icon: "phone-portrait-outline",
      order: 6,
      active: true,
    },
    {
      id: "computers",
      name: "Computers",
      arabicName: "أجهزة الكمبيوتر",
      icon: "laptop-outline",
      order: 7,
      active: true,
    },
    {
      id: "tvs-audio",
      name: "TVs & Audio",
      arabicName: "التلفزيونات والصوتيات",
      icon: "tv-outline",
      order: 8,
      active: true,
    },
    {
      id: "cameras",
      name: "Cameras",
      arabicName: "الكاميرات",
      icon: "camera-outline",
      order: 9,
      active: true,
    },
    {
      id: "gaming",
      name: "Gaming",
      arabicName: "الألعاب",
      icon: "game-controller-outline",
      order: 10,
      active: true,
    },
    {
      id: "watches",
      name: "Watches",
      arabicName: "الساعات",
      icon: "watch-outline",
      order: 11,
      active: true,
    },
    {
      id: "jewelry",
      name: "Jewelry",
      arabicName: "المجوهرات",
      icon: "diamond-outline",
      order: 12,
      active: true,
    },
    {
      id: "bags",
      name: "Bags",
      arabicName: "الحقائب",
      icon: "bag-handle-outline",
      order: 13,
      active: true,
    },
    {
      id: "fashion",
      name: "Fashion",
      arabicName: "الأزياء",
      icon: "shirt-outline",
      order: 14,
      active: true,
    },
    {
      id: "accessories",
      name: "Accessories",
      arabicName: "الإكسسوارات",
      icon: "glasses-outline",
      order: 15,
      active: true,
    },
    {
      id: "perfumes",
      name: "Perfumes",
      arabicName: "العطور",
      icon: "flower-outline",
      order: 16,
      active: true,
    },
    {
      id: "furniture",
      name: "Furniture",
      arabicName: "الأثاث",
      icon: "bed-outline",
      order: 17,
      active: true,
    },
    {
      id: "home-appliances",
      name: "Home Appliances",
      arabicName: "الأجهزة المنزلية",
      icon: "home-outline",
      order: 18,
      active: true,
    },
    {
      id: "real-estate",
      name: "Real Estate",
      arabicName: "العقارات",
      icon: "business-outline",
      order: 19,
      active: true,
    },
    {
      id: "art-collectibles",
      name: "Art & Collectibles",
      arabicName: "الفنون والمقتنيات",
      icon: "color-palette-outline",
      order: 20,
      active: true,
    },
    {
      id: "antiques",
      name: "Antiques",
      arabicName: "التحف",
      icon: "hourglass-outline",
      order: 21,
      active: true,
    },
    {
      id: "sports-fitness",
      name: "Sports & Fitness",
      arabicName: "الرياضة واللياقة",
      icon: "fitness-outline",
      order: 22,
      active: true,
    },
    {
      id: "toys-kids",
      name: "Toys & Kids",
      arabicName: "الألعاب والأطفال",
      icon: "happy-outline",
      order: 23,
      active: true,
    },
    {
      id: "tools-equipment",
      name: "Tools & Equipment",
      arabicName: "الأدوات والمعدات",
      icon: "hammer-outline",
      order: 24,
      active: true,
    },
    {
      id: "business-industrial",
      name: "Business & Industrial",
      arabicName: "الأعمال والصناعة",
      icon: "briefcase-outline",
      order: 25,
      active: true,
    },
    {
      id: "others",
      name: "Others",
      arabicName: "أخرى",
      icon: "grid-outline",
      order: 26,
      active: true,
    },
  ];
  